<template>
   <v-text-field :rules="[rules.validate]"   v-model="selectedValue" @input="onSelect()">
                   <template slot="label"><span v-html="$t('labels.Email')" /></template>
    </v-text-field>     

</template> 

<style scoped>
.copy-phone {
  margin-left: 5px;
}
</style>
<script>
export default {
  props: [
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam"
  ],
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        return;
      }
      var isvalidemail = this.validateEmail();
      if (isvalidemail) {
        this.$emit("input", this.selectedValue);
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalidemail);
      } catch (e) {
        // ignore
      }
    },
    validateEmail() {
      if (!this.selectedValue) return true;
      // var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.selectedValue);
    },
    onCopyFrom() {
      try {
        this.selectedValue = this.copyfrom_sourcefield;
        this.$emit("input", this.selectedValue);
      } catch (e) {
        // ignore
      }
    }
  },
  data() {
    return {
      selectedValue: this.value,
      rules: {         
          validate: value => {
             const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
    };
  },
  computed: {
    isValidate() {
      return this.validateEmail();
    }
  },
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  }
};
</script>
 